import get from 'lodash/get'
import has from 'lodash/has'
import isNil from 'lodash/isNil'

export const joinFieldsByPaths = <DataT>(source: DataT, paths: string[], separator: string = '-', defaultValue: string | number = 0): string => {
  return paths.reduce<(string | number)[]>((acc, path) => {
    if (!has(source, path)) {
      useLogger().warn(`Path ${path} not found in data`, { data: source })
    }

    const value = get(source, path, defaultValue) ?? defaultValue

    if (value !== undefined || !isNil(value)) {
      acc.push(String(value))
    }

    return acc
  }, []).join(separator)
}
